<template>
  <Dialog
    v-on="$listeners"
    v-bind="$props"
    title="活动规则"
    noOkBtn
    noCancelBtn
    textAlign="left"
  >
    <div :class="$style.rule">
      <slot></slot>
    </div>
  </Dialog>
</template>

<script>
import Dialog from "./Dialog";

export default {
  name: "RuleDialog",
  props: Dialog.props,
  components: {
    Dialog,
  },
};
</script>

<style lang="scss" module>
@import "~style/tool";

.rule {
  font-size: 13px;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  white-space: pre-line;
  word-break: break-all;
}
</style>
